import * as S from "./styles";

export const ContentModal = ({ children }) => {
  return <S.ContentModal>{children}</S.ContentModal>;
};
